/* istanbul ignore file */
import {
  bankLinkSuccessCoreContinue,
  institutionsCoreSkip,
  portfolioLaterContinue,
  signupCoreContinue,
  startInvestingCoreNext,
} from '../../redirects'
import { FlowEntry, FlowRoute } from '../../types'

// LATER Flow
const later: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Signup }],
    progress: {
      stepIndex: -1,
      stepPartialProgress: 0.1,
      stepOverallProgress: 0,
    },
  },
  {
    page: FlowRoute.Signup,
    actions: [{ name: 'continue', stepEvent: 'create_account', goTo: () => FlowRoute.Funding }],
    progress: {
      stepIndex: 0,
      stepPartialProgress: 0,
      stepOverallProgress: 5,
    },
  },
  {
    page: FlowRoute.Funding,
    actions: [
      { name: 'partner_skip', goTo: signupCoreContinue },
      { name: 'continue', stepEvent: 'link_bank_interstitial', goTo: () => FlowRoute.Institutions },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 0,
      stepOverallProgress: 10,
    },
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'partner_skip', goTo: institutionsCoreSkip },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.PlaidLinkRedirect,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'partner_skip', goTo: institutionsCoreSkip },
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      { name: 'skip', goTo: institutionsCoreSkip },
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      { name: 'continue', stepEvent: 'link_bank', goTo: () => FlowRoute.BankLinkSuccess },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [{ name: 'continue', goTo: bankLinkSuccessCoreContinue }],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 65,
      stepOverallProgress: 20,
    },
  },
  {
    page: FlowRoute.RoundUpsInterstitial,
    actions: [{ name: 'continue', goTo: () => FlowRoute.RecurringInvestment }],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.PersonalInfo,
    actions: [
      { name: 'continue', stepEvent: 'information_personal', goTo: () => FlowRoute.ContactInfo },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 0,
      stepOverallProgress: 25,
    },
  },
  {
    page: FlowRoute.ContactInfo,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_contact',
        goTo: () => FlowRoute.MFASetup,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 75,
      stepOverallProgress: 30,
    },
  },
  {
    page: FlowRoute.MFASetup,
    actions: [
      {
        name: 'continue',
        stepEvent: 'setup_mfa',
        goTo: () => FlowRoute.InvestorQuestions,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 80,
      stepOverallProgress: 40,
    },
  },
  {
    page: FlowRoute.InvestorQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'information_investor_questions',
        goTo: () => FlowRoute.SuitabilityInterstitial,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 85,
      stepOverallProgress: 50,
    },
  },
  {
    page: FlowRoute.SuitabilityInterstitial,
    actions: [
      {
        name: 'continue',
        stepEvent: 'suitability_interstitial',
        goTo: () => FlowRoute.LaterSuitabilityQuestions,
      },
      {
        name: 'skip',
        goTo: () => FlowRoute.RecurringInvestment,
      },
    ],
    progress: { stepIndex: 2, stepPartialProgress: 90, stepOverallProgress: 60 },
  },
  {
    page: FlowRoute.LaterSuitabilityQuestions,
    actions: [
      { name: 'continue', stepEvent: 'portfolio_questions', goTo: () => FlowRoute.Analyzing },
    ],
    progress: { stepIndex: 2, stepPartialProgress: 92, stepOverallProgress: 60 },
  },
  {
    page: FlowRoute.SuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_questions',
        goTo: () => FlowRoute.PortfolioOverview,
      },
    ],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 92,
      stepOverallProgress: 60,
    },
  },
  {
    page: FlowRoute.Analyzing,
    actions: [
      {
        name: 'continue',
        stepEvent: 'analyzing_portfolio',
        goTo: () => FlowRoute.PortfolioRecommendation,
      },
    ],
    progress: { stepIndex: 2, stepPartialProgress: 94, stepOverallProgress: 65 },
  },
  {
    page: FlowRoute.SecondChanceBankLink,
    actions: [
      { name: 'continue', goTo: () => FlowRoute.Institutions },
      { name: 'skip', stepEvent: 'initial_investment', goTo: () => FlowRoute.Success },
    ],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    },
  },
  {
    page: FlowRoute.PortfolioRecommendation,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_recommendation',
        goTo: portfolioLaterContinue,
      },
      { name: 'ineligible', stepEvent: 'portfolio_recommendation', goTo: () => FlowRoute.Success },
    ],
    progress: { stepIndex: 2, stepPartialProgress: 94, stepOverallProgress: 75 },
  },
  {
    page: FlowRoute.OneTimeInvestment,
    actions: [
      { name: 'continue', stepEvent: 'initial_investment', goTo: startInvestingCoreNext },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
    ],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    },
  },
  {
    page: FlowRoute.RecurringInvestment,
    actions: [
      {
        name: 'one-time',
        stepEvent: 'initial_investment',
        goTo: () => FlowRoute.OneTimeInvestment,
      },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'continue', stepEvent: 'initial_investment', goTo: startInvestingCoreNext },
    ],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 90,
    },
  },
  {
    page: FlowRoute.Success,
    actions: [{ name: 'referral-reward', goTo: () => FlowRoute.ReferralReward }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 100,
    },
  },
  {
    page: FlowRoute.ReferralReward,
    actions: [{ name: 'continue', goTo: () => FlowRoute.ReferralDisclosure }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 95,
    },
  },
  {
    page: FlowRoute.ReferralDisclosure,
    actions: [{ name: 'continue', goTo: () => FlowRoute.Success }],
    progress: {
      stepIndex: 3,
      stepPartialProgress: 0,
      stepOverallProgress: 95,
    },
  },
]

export default later
